var MessageMobileCtrl = function($state, $stateParams) {
    this.state = $state;
    this.box = $stateParams.box;
};

MessageMobileCtrl.prototype.goBack = function() {
    this.state.go('private.main.messages', {box: this.box});
};

module.exports = MessageMobileCtrl;